import { render, staticRenderFns } from "./tiSpecialDialog.vue?vue&type=template&id=dca9a284"
import script from "./tiSpecialDialog.vue?vue&type=script&lang=js"
export * from "./tiSpecialDialog.vue?vue&type=script&lang=js"
import style0 from "./tiSpecialDialog.vue?vue&type=style&index=0&id=dca9a284&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports